import { tryNewDate } from '@/helpers/dto2resource';
import DetalheDividaDto from '../dto/DetalheDividaDto';
import DividaParametros from '../dto/DividaParametros';
import DividaPropostaDto from '../dto/DividaPropostaDto';
import ComposicaoDividaResource from './ComposicaoDividaResource';

export default class DividaPropostaResource {
  id: number;
  codigoContrato: string | null;
  codigoCredor: number;
  descricao: string | null;
  dataOrigem: Date;
  dataChegada?: Date;
  valorPrincipal?: number | null;
  valorTotal?: number | null;
  valorVencidoTotal?: number | null;
  valorAcrescimos?: number | null;
  valorVencido?: number | null;
  valorVincendo?: number | null;
  credor: string;
  credorOrigem?: string;
  api: string;
  produto?: string;
  detalhe: DetalheDividaDto | null;
  interface: string;
  parametros?: DividaParametros;
  composicao: ComposicaoDividaResource[];
  fluxoNegociacao?: string | null;

  constructor(dto: DividaPropostaDto) {
    this.id = dto.id;
    this.codigoContrato = dto.codigoContrato;
    this.codigoCredor = dto.codigoCredor;
    this.descricao = dto.descricao;
    this.dataOrigem = new Date(dto.dataOrigem);
    this.dataChegada = tryNewDate(dto.dataChegada);
    this.valorPrincipal = dto.valorPrincipal;
    this.valorTotal = dto.valorTotal;
    this.valorVencidoTotal = dto.valorVencidoTotal;
    this.valorAcrescimos = dto.valorAcrescimos;
    this.valorVencido = dto.valorVencido;
    this.valorVincendo = dto.valorVincendo;
    this.credor = dto.credor;
    this.credorOrigem = dto.credorOrigem ?? undefined;
    this.api = dto.api;
    this.produto = dto.detalhe?.produto || dto.produto || undefined;
    this.detalhe = dto.detalhe;
    this.parametros = dto.parametros;
    this.composicao = dto.composicao?.map((c) => new ComposicaoDividaResource(c)) || [];
    this.interface = (dto.detalhe?.tema || dto.api).replace(/^mc-/, '');
    this.fluxoNegociacao = 'Padrao';
  }

  get possuiComposicao(): boolean {
    return this.composicao.length > 1;
  }

  get ofuscada(): boolean {
    return !!this.parametros?.requerAutenticacao2FA;
  }

  get possuiSincronizacaoParcela(): boolean {
    if (this.parametros?.possuiSincronizacaoParcela === undefined) {
      return true;
    }
    return !!this.parametros?.possuiSincronizacaoParcela;
  }

  get permitePagamentoAposVencimento() {
    return !this.parametros || this.parametros.permitePagamentoAposVencimento;
  }

  get contratos() {
    return this.codigoContrato
      ? [this.codigoContrato]
      : this.composicao
        .filter((comp) => comp.codigoContrato)
        .map((comp) => comp.codigoContrato);
  }

  get logo(): string {
    return this.detalhe?.logo || this.api;
  }

}
